<template>
  <div>
    <!-- suppress any class from being applied to q-card -->
    <q-card
      v-bind="{ bordered: !spinner, ...$attrs, class: null }"
      class="peg-alert rounded-borders"
      :class="{
        dense,
        error,
        info,
        warning,
        [colorClasses]: true,
        icon: !!icon,
        'q-py-sm q-px-md text-caption': dense,
        'q-pa-md': !dense,
      }"
      :style="{ height: height }"
      flat
    >
      <q-icon v-if="icon" class="alert-icon" :size="dense ? 'xs' : 'sm'" :name="getIcon()" />
      <div class="content">
        <div
          v-if="$slots?.header"
          class="text-weight-semibold flex flex-center"
          :class="$slots.default ? (dense ? 'q-mb-sm' : 'q-mb-md') : ''"
        >
          <q-icon v-if="headerIcon" class="q-mr-xs" :name="getIcon()" />
          <slot name="header" />
        </div>

        <div
          class="alert-message flex flex-center no-wrap full-height"
          :class="{ 'text-grey-10': !!$slots?.header, 'text-center': centered, 'text-left': !centered }"
        >
          <span v-if="spinner" :class="{ 'q-mr-sm': $slots?.default }">
            <q-spinner-ball v-if="spinner === 'ball'" size="md" />
            <q-spinner-gears v-else-if="spinner === 'gears'" size="md" />
            <q-spinner v-else-if="spinner === 'circle'" size="md" />
            <q-spinner-dots v-else size="md" />
          </span>

          <slot />
        </div>
      </div>
    </q-card>
  </div>
</template>

<script setup>
const props = defineProps({
  dense: { type: Boolean, required: false, default: false },
  success: { type: Boolean, required: false, default: false },
  error: { type: Boolean, required: false, default: false },
  info: { type: Boolean, required: false, default: false },
  spinner: { type: [Boolean, String], required: false, default: false },
  warning: { type: Boolean, required: false, default: false },
  centered: { type: Boolean, required: false, default: false },
  height: { type: String, required: false, default: 'auto' },
  icon: { type: [Boolean, String], required: false, default: false },
  headerIcon: { type: [Boolean, String], required: false, default: false },
  plain: { type: Boolean, required: false, default: false },
  fullWidth: { type: Boolean, required: false, default: false },
})
const { success, error, info, warning, icon, plain } = toRefs(props)

const colorClasses = computed(() => {
  let classes = 'text-grey-8'

  if (!plain.value) {
    classes = 'bg-grey-3 text-grey-8'
  }

  if (success.value) {
    classes = 'bg-positive-light text-positive-dark'
  }
  if (error.value) {
    classes = 'bg-negative-light text-negative'
  }
  if (info.value) {
    classes = 'bg-info-light text-info-dark'
  }
  if (warning.value) {
    classes = 'bg-warning-light text-warning-dark'
  }

  return classes
})

function getIcon() {
  if (typeof icon.value === 'string') {
    return icon.value
  }
  if (success.value) {
    return 'fas fa-circle-check'
  }
  if (error.value) {
    return 'fas fa-octagon-exclamation'
  }
  if (info.value) {
    return 'fas fa-info-circle'
  }
  if (warning.value) {
    return 'fas fa-exclamation-triangle'
  }
  return ''
}
</script>

<style lang="scss" scoped>
.icon {
  .content {
    margin-left: 24px;
  }
}
.alert-icon {
  position: absolute;
  top: 4px;
  left: 2px;
}

.dense .alert-message * {
  line-height: 1.1rem;
}
</style>
